<template>
  <div>
    <v-date-picker
      :weekday-format="getDay"
      v-model="picker"
      full-width
      first-day-of-week="-1"
      show-adjacent-months
      :min="new Date().toISOString()"
      color="primary"
      ref="date-picker-ref"
      @input="updateDate"
      :locale="$store.state.core.widgetParameters.lang"
    ></v-date-picker>

    <div class="horizontal-calendar-wrap">
      <h4 class="week-title">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.333 4.3335V2.3335H10.9997V3.00016H9.66634V2.3335H4.33301V3.00016H2.99967V2.3335H1.66634V4.3335H12.333ZM12.333 5.66683H1.66634V12.3335H12.333V5.66683ZM10.9997 1.00016H12.333C13.0694 1.00016 13.6663 1.59712 13.6663 2.3335V12.3335C13.6663 13.0699 13.0694 13.6668 12.333 13.6668H1.66634C0.929961 13.6668 0.333008 13.0699 0.333008 12.3335V2.3335C0.333008 1.59712 0.929961 1.00016 1.66634 1.00016H2.99967V0.333496H4.33301V1.00016H9.66634V0.333496H10.9997V1.00016ZM4.99967 8.3335H3.66634V7.00016H4.99967V8.3335ZM7.66634 8.3335H6.33301V7.00016H7.66634V8.3335ZM10.333 8.3335H8.99967V7.00016H10.333V8.3335ZM4.99967 11.0002H3.66634V9.66683H4.99967V11.0002ZM7.66634 11.0002H6.33301V9.66683H7.66634V11.0002Z" fill="#9099A9"/>
        </svg>
        <span>
          {{ (new Date(currentFirstDay.timestamp)).toLocaleString(getLang(), { month: "long" }) }}
          {{ currentFirstDay.year }}
        </span>
      </h4>
      <vue-horizontal-calendar
        style="width:410px;margin: 0 auto;"
        swipeSpace="7"
        lang="en"
        :minDate="new Date().toISOString()"
        :choosedDate="horizontalPicker"
        choosedItemColor="#2B2E6C"
        choosedDatePos="center"
        :showBorderTop="false"
        v-on:firstDayChange="firstDayChange"
        @change="updateSelectedDate"
      ></vue-horizontal-calendar>
    </div>
  </div>
</template>

<script>
import VueHorizontalCalendar from 'vue-horizontal-calendar';

export default {
  
  name: "date-picker",

  components: {
      VueHorizontalCalendar
  },
  props: [
    "availableDates",
  ],

  data: () => ({
    picker: null,
    horizontalPicker: null,
    currentFirstDay: {
        dateFormat: "",
        year: "",
        month: "",
        date: "",
        day: "",
        timestamp: ""
      },
  }),
  computed: {
    // getCurrentDate() {
    //   const current = new Date(Date.parse(this.horizontalPicker || new Date()));
    //   return current ? current.getFullYear() + "/" + (current.getMonth() + 1) + "/" + current.getDate(): this.getThisMondayDate;
    // },
    getThisMondayDate(){
      let today = new Date();
      let today_weekCode = today.getDay() == 0? 7: today.getDay();
      let monday_timestamp = today.getTime() - (today_weekCode - 1) * 1000*3600*24;
      let monday = new Date(monday_timestamp);
      return monday.getFullYear() + "/" + (monday.getMonth() + 1) + "/" + monday.getDate();
    }
  },
  beforeMount() {
    this.picker = new Date().toISOString().slice(0, 10);
    this.updateDate();
  },

  methods: {
    firstDayChange(day) {
      this.currentFirstDay = day;
    },
    updateSelectedDate(day) {
      this.horizontalPicker = day.dateFormat
      this.picker = day.dateFormat.replace(/\//g, '-');
      this.updateDate();
      console.log('updateDate',day.dateFormat);
      this.$emit("input", this.picker);
    },
    getDay(date) {
      const daysOfWeek = [this.$t('weekDaysText.Sunday'), this.$t('weekDaysText.Monday'), this.$t('weekDaysText.Tuesday'), this.$t('weekDaysText.Wednesday'), this.$t('weekDaysText.Thursday'), this.$t('weekDaysText.Friday'), this.$t('weekDaysText.Saturday')];
      let i = new Date(date).getDay(date);
      return daysOfWeek[i];
    },
    getAllowedDates(val) {
      // val = val.replace(/-/g, '/');
      // val = moment(val).format('MM/DD/YYYY')
      return this.availableDates.indexOf(val) !== -1;
    },
    updateDate() {
      this.horizontalPicker = this.picker.replace(/-/g, '/')
      this.$emit("input", this.picker);
    },
    getLang() {
      return this.$store.state.core.widgetParameters.lang.split('_')[0] + '-eg';
    },
  },
};
</script>
<style lang="scss">
.v-picker {
  height: 100%!important;
}
.booking-steps {
  .v-date-picker-table {
    .v-btn.primary {
      background: var(--secondaryColor)!important;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif!important;     
    }
    @media (max-width: 960px) {
      height: auto !important;
    }

    table th {
      color: #616E85 !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      text-transform: uppercase !important;

      @media screen and (max-width: 959px) {
        font-size: 7px !important;
      }
    }
  }

  .v-date-picker-table--date {
    .v-btn {
      color: var(--secondaryColor);
      
      &--active {
        color: white;
      }
    }
  }

  .v-picker--date {
    display: block;
    
    @media screen and (max-width: 959px) {
      display: none;
    }
  }

  .horizontal-calendar-wrap {
    display: none;

    @media screen and (max-width: 959px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin: 10px 0 20px;
      position: relative;
    }
  }
}

.week-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--secondaryColor);
  display: flex;
  align-items: center;
  gap: 8px;
}

.horizontal-calendar {
  border: 0;

  .left-arrow,
  .right-arrow {
    position: absolute;
    top: -15px;
    width: 30px;
    height: 50px;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: 0;
  }

  .left-arrow {
    left: 0;
  }

  .right-arrow {
    right: 0;
  }

  .date-list {
    margin-inline-start: 30px;
    padding-top: 10px;

    @media screen and (max-width: 400px) {
      margin-inline-start: 10px !important;
    }

    @media screen and (max-width: 370px) {
      margin-inline-start: 0 !important;
    }

    .date-item {
      height: 55px;
      width: 50px;
      margin-inline: 4px;
      border: 0;
      box-sizing: border-box;
      border-radius: 10px;

      div {
        box-sizing: border-box;
        border: 1px solid #F2F3F4;
        height: 55px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 4px;

        .date-item-day {
          font-size: 12px;
          font-weight: 400;
          color: #616E85;
        }

        .date-item-date {
          font-size: 18px;
          font-weight: 500;
          color: var(--secondaryColor);
        }
      }

      &.choosed-day div {
        .date-item-date,
        .date-item-day {
          color: white;
        }
      }
    }
  }

  .date-list-scroll {
    height: 55px;
    display: flex;
  }

  .first-day {
    width: 50px;
  }
}
</style>
